module.exports = __webpack_public_path__ + "img/hero4.34755c48.jpg";